export function IconCriarNovaTarefa() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 1.27594C10.9323 1.27594 13.7241 4.06856 13.7241 7.5C13.7241 10.9314 10.9314 13.7241 7.5 13.7241C4.06856 13.7241 1.27594 10.9323 1.27594 7.5C1.27594 4.06771 4.06856 1.27594 7.5 1.27594ZM7.5 0C3.35829 0 0 3.35829 0 7.5C0 11.6417 3.35829 15 7.5 15C11.6417 15 15 11.6417 15 7.5C15 3.35829 11.6426 0 7.5 0Z"
        fill="white"
      />
      <path
        d="M8.13818 8.13671L11.2972 8.13671C11.6497 8.13671 11.9354 7.85101 11.9354 7.49854C11.9354 7.14607 11.6497 6.86036 11.2972 6.86036L8.13818 6.86036L8.13818 3.70136C8.13818 3.34889 7.85247 3.06318 7.5 3.06318C7.14753 3.06318 6.86182 3.34889 6.86182 3.70136L6.86182 6.86036L3.70282 6.86036C3.35035 6.86036 3.06464 7.14607 3.06464 7.49854C3.06464 7.67417 3.13562 7.83417 3.2511 7.94965C3.36659 8.06514 3.52598 8.13671 3.70222 8.13611L6.86122 8.13611L6.86122 11.2951C6.86122 11.4708 6.9322 11.6307 7.04768 11.7462C7.16317 11.8617 7.32256 11.9333 7.4988 11.9327C7.85127 11.9327 8.13697 11.647 8.13697 11.2945L8.13697 8.13551L8.13818 8.13671Z"
        fill="white"
      />
    </svg>
  );
}

export function IconEdit() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
    </svg>
  );
}

export function IconDelete() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
    </svg>
  );
}
